import {makeStyles} from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  bannerEvent: {
    textDecoration: "none",
  },
}));
